<template>
  <div class="page-wrapper">

    <div class="page p-resources">
      <menu-item></menu-item>

      <div class="page-content">

        <div class="p-section">
          <div class="p-box pure-g">
            <div class="box-left pure-u-1-1 pure-u-md-1-2">
              <h2 v-html="$lang.recourses"></h2>
              <p v-html="$lang.rec_ingress"></p>
            </div>
            <div class="pure-u-1-1 pure-u-md-1-2"></div>
          </div>
        </div>

        <div class="a-box no-m-t beige">
          <div class="pure-g">
            <div class="pdf-box pure-u-1-1 pure-u-md-1-2">
              <a v-for="(pdf, i) in pdfs.left" :key="i"
                 class="pdf-link"
                 :href="('./static/pdf/' + pdf.link)"
                 target="_blank"
              >
                {{ $lang[pdf.name] }}
                <span class="icon-pdf"></span>
              </a>
            </div>
            <div class="pdf-box pure-u-1-1 pure-u-md-1-2">
              <a v-for="(pdf, i) in pdfs.right" :key="i"
                 class="pdf-link"
                 :href="('./static/pdf/' + pdf.link)"
                 target="_blank"
              >
                {{ $lang[pdf.name] }}
                <span class="icon-pdf"></span>
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- To next part -->
    <div class="to-next-box resourses">
      <h4 v-html="$lang.done_part_recourse"></h4>
      <div class="btn-holder">
        <div class="btn white arrow" v-touch:tap="toPartOne">
          <p>{{ $lang.to_part_small }} 1</p>
        </div>
        <div class="btn white arrow" v-touch:tap="toPartTwo">
          <p>{{ $lang.to_part_small }} 2</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Menu from '../../../components/menu'
import PDFS from '../../../assets/data/recourse_pdf.json'

export default {
  name: 'page-resource',
  data () {
    return {
      overlay: false,
      pdfs: PDFS
    }
  },
  beforeMount () {
    this.$root.shared.currentPage = 'Recourses'
  },
  mounted () {
    this.util.addBodyClass('recourse-bg')
  },
  methods: {
    toPartOne () {
      return this.onToPartOne()
    },
    onToPartOne () {
      this.$router.push({'name': 'Improvement'})
    },
    toPartTwo () {
      return this.onToPartTwo()
    },
    onToPartTwo () {
      this.$router.push({'name': 'Dementia'})
    }
  },
  beforeDestroy () {
    this.util.removeBodyClass('recourse-bg')
  },
  components: {
    'menu-item': Menu
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/recourses/index.vue